import axios from "axios";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { NotificationManager } from "react-notifications";
import { useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import contact from "../../assets/svgs/account.svg";
import DownArrow from "../../assets/svgs/down-arrow.svg";
import sortAsce from "../../assets/svgs/sort-ascending.svg";
import sortDesc from "../../assets/svgs/sort-descending.svg";
import swap from "../../assets/svgs/swap-vertical.svg";
import UpArrow from "../../assets/svgs/up-arrow.svg";
import ActionsMenu from "../../components/ActionsMenu";
import BarData from "../../components/Charts/BarData";
import CircleChart from "../../components/Charts/CircleChart";
import ClosedModal from "../../components/ConfirmationModals/ClosedModal";
import ContractModal from "../../components/ConfirmationModals/ContractModal";
import DeleteConfirmationModal from "../../components/ConfirmationModals/DeleteConfirmationModal";
import ExpiredModal from "../../components/ConfirmationModals/ExpiredModal";
import WithdrawnModal from "../../components/ConfirmationModals/WithdrawnModal";
import Loader from "../../components/Loader";
import ContactPagination from "../../components/Pagination/ContactPagination";
import useAuth from "../../hooks/useAuth";
import BaseLayout from "../../layouts/BaseLayout";
import { BASE_URL } from "../../utils/Element";
import { initialExclusiveFilterData } from "../../utils/initialData";
import LeadDataContainer from "../Leads/components/LeadDataContainer";
import LeadDataContainer2 from "../Leads/components/LeadDataContainer2";
import AddExclusiveModal from "./AddExclusiveModal";
import ExclusiveFilter from "./components/ExclusiveFilter";
import EditExclusiveModal from "./EditExclusiveModal";

// Custom debounce hook
const useDebounce = (value, delay = 600) => {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    return () => clearTimeout(handler);
  }, [value, delay]);

  return debouncedValue;
};

const Exclusives = () => {
  const [config] = useAuth();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [selectedId, setSelectedId] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemPerPage, setItemPerPage] = useState(50);
  const [sortBy, setSortBy] = useState("id");
  const [sortDirection, setSortDirection] = useState("asc");
  const [exclusiveData, setExclusiveData] = useState([]);
  const [showAddModal, setShowAddModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [disableDelete, setDisableDelete] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [expandedRows, setExpandedRows] = useState({});
  const [showExpiredModal, setShowExpiredModal] = useState(false);
  const [showWithdrawnModal, setShowWithdrawnModal] = useState(false);
  const [ShowClosedModal, setShowClosedModal] = useState(false);
  const [exclusiveDashboard, setExclusiveDashboard] = useState();
  const [pageNumber, setPageNumber] = useState(1);
  const [activeTab, setActiveTab] = useState(0);
  const [activeChildTab, setActiveChildTab] = useState(0);
  const [showContractModal, setShowContractModal] = useState(false);
  const [activeDropdown, setActiveDropdownTab] = useState();
  const isSidebarCollapsed = useSelector((state) => state.isSidebarCollapsed);

  const [filterData, setFilterData] = useState(() => {
    const localFilterData = localStorage.getItem("filterData");
    return localFilterData ? JSON.parse(localFilterData) : initialExclusiveFilterData;
  });

  const [paginationData, setPaginationData] = useState({ totalItems: 0, from: 0, to: 0, totalPages: 0 });
  const [filterStatus, setFilterStatus] = useState({
    exclusive_new_listing_quater: false,
    exclusive_total_active_listing: false,
    bov_exclusive_convertion_rate: false,
    total_volumn: false,
  });

  // ==================== Debounced Search ====================
  const [searchInput, setSearchInput] = useState("");
  const debouncedSearch = useDebounce(searchInput, 600);
  const [search, setSearch] = useState("");

  // Trigger API only when >= 3 chars or cleared
  useEffect(() => {
    if (debouncedSearch.length >= 3 || debouncedSearch === "") {
      setSearch(debouncedSearch);
    }
  }, [debouncedSearch]);

  const handleInputChange = (e) => {
    const newValue = e.target.value;
    const trimmed = newValue.startsWith(" ") ? newValue.trimStart() : newValue;
    setSearchInput(trimmed);
  };

  // ==================== Existing Logic ====================
  const handleNext = () => {
    if (pageNumber !== paginationData.totalPages) {
      setPageNumber(pageNumber + 1);
    }
  };

  const handlePrev = () => {
    if (pageNumber > 1) {
      setPageNumber(pageNumber - 1);
    }
  };

  useEffect(() => {
    setPageNumber(1);
    onSuccess();
  }, [activeTab, search, itemPerPage, activeChildTab]);

  useEffect(() => {
    onSuccess();
  }, [pageNumber]);

  const buildQueryParams = (filters) => {
    let params = `page=${currentPage}&per_page=${itemPerPage}`;
    if (search) {
      params += `&search=${encodeURIComponent(search)}`;
    }

    const { contact, property_name, created_at, noi, exclusive_price, min_asking_cap_rate, max_asking_cap_rate, min_asking_price, max_asking_price, listing_broker,
      created_start_date, created_end_date, exclusive_new_listing_quater, exclusive_total_active_listing, bov_exclusive_convertion_rate, total_volumn, status , exclusives_over_30_days_no_offer
  } = filters;

    if (contact?.id !== "") {
      params += `&contact=${encodeURIComponent(contact?.id)}`;
    }
    if (exclusive_price) params += `&exclusive_price=${encodeURIComponent(exclusive_price)}`;
    if (property_name) params += `&property_name=${encodeURIComponent(property_name)}`;
    if (created_at) params += `&created_at=${encodeURIComponent(created_at)}`;
    if (noi) params += `&noi=${encodeURIComponent(noi)}`;
    if (status) params += `&status=${encodeURIComponent(status)}`;
    if (listing_broker) params += `&listing_broker=${encodeURIComponent(listing_broker)}`;
    if (exclusives_over_30_days_no_offer) params += `&exclusives_over_30_days_no_offer=${encodeURIComponent(exclusives_over_30_days_no_offer)}`;
    if (min_asking_cap_rate) params += `&min_asking_cap_rate=${encodeURIComponent(min_asking_cap_rate)}`;
    if (max_asking_cap_rate) params += `&max_asking_cap_rate=${encodeURIComponent(max_asking_cap_rate)}`;
    if (min_asking_price) params += `&min_asking_price=${encodeURIComponent(min_asking_price)}`;
    if (max_asking_price) params += `&max_asking_price=${encodeURIComponent(max_asking_price)}`;
    if (created_start_date) params += `&created_start_date=${encodeURIComponent(created_start_date)}`;
    if (created_end_date) params += `&created_end_date=${encodeURIComponent(created_end_date)}`;
    if (exclusive_new_listing_quater) params += `&exclusive_new_listing_quater=${encodeURIComponent(exclusive_new_listing_quater)}`;
    if (exclusive_total_active_listing) params += `&exclusive_total_active_listing=${encodeURIComponent(exclusive_total_active_listing)}`;
    if (total_volumn) params += `&total_volumn=${encodeURIComponent(total_volumn)}`;
    if (bov_exclusive_convertion_rate) params += `&bov_exclusive_convertion_rate=${encodeURIComponent(bov_exclusive_convertion_rate)}`;

    if (sortDirection && sortBy !== "id") {
      params += `&sort_direction=${sortDirection}`;
    }
    if (sortBy !== "id") {
      params += `&sort_by=${sortBy}`;
    }

    return params;
  };

  const fetchExclusive = (filters) => {
    const queryParams = buildQueryParams({
      ...filters,
      exclusive_new_listing_quater: filterStatus.exclusive_new_listing_quater,
      exclusive_total_active_listing: filterStatus.exclusive_total_active_listing,
      bov_exclusive_convertion_rate: filterStatus.bov_exclusive_convertion_rate,
      total_volumn: filterStatus.total_volumn,
    });

    axios
      .get(`${BASE_URL}/exclusive-listing?active_tab=${activeTab}&${queryParams}`, config)
      .then((res) => {
        const value = res?.data?.exclusives;
        setExclusiveData(value?.data || []);
        setPaginationData({
          totalItems: value?.total ?? 0,
          from: value?.from ?? 0,
          to: value?.to ?? 0,
          totalPages: value?.last_page ?? 0,
        });
      })
      .catch((err) => {
        if (err.response?.data?.message && err.response?.data?.message !== "Too Many Attempts.") {
          NotificationManager.error(err.response?.data?.message);
        }
      })
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    fetchExclusive(filterData);
  }, [sortDirection, sortBy, filterStatus]);

  useEffect(() => {
    onSuccess();
  }, [search, currentPage, itemPerPage]);

  const onSuccess = (filters) => {
    setLoading(true);
    if (filters) {
      fetchExclusive(filters);
    } else {
      fetchExclusive(filterData);
    }
  };

  const handleDelete = () => {
    setDisableDelete(true);
    axios
      .delete(`${BASE_URL}/delete-exclusive/${selectedId}`, config)
      .then((res) => {
        setSelectedId("");
        onSuccess();
        setShowDeleteModal(false);
        if (res?.data?.message) {
          NotificationManager.success(res?.data?.message);
        }
      })
      .catch((err) => {
        if (err.response?.data?.message && err.response?.data?.message !== "Too Many Attempts.") {
          NotificationManager.error(err.response?.data?.message);
        }
      })
      .finally(() => setDisableDelete(false));
  };

  const fetchOptions = () => {
    axios
      .post(`${BASE_URL}/status/${selectedId}`, { status: activeDropdown }, config)
      .then((res) => {
        onSuccess();
        setShowExpiredModal(false);
        setShowWithdrawnModal(false);
        setShowClosedModal(false);
        if (res?.data?.message) {
          NotificationManager.success(res?.data?.message);
        }
      })
      .catch((err) => {
        if (err.response?.data?.message && err.response?.data?.message !== "Too Many Attempts.") {
          NotificationManager.error(err.response?.data?.message);
        }
      })
      .finally(() => setLoading(false));
  };

  const data = exclusiveDashboard?.exclusive_day_off_market;

  const BarGraphData = [
    { name: "<$1M", count: exclusiveDashboard?.count_less_than_million },
    { name: "$1M-$3M", count: exclusiveDashboard?.count_between_than_three_million },
    { name: ">$3M", count: exclusiveDashboard?.count_greater_than_three_million }
  ];

  const toggleRowDetails = (id) => {
    setExpandedRows((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };

  const fetchDashboardData = () => {
    setLoading(true);
    axios
      .get(`${BASE_URL}/dashboard-exclusive?active_tab=${activeTab}`, config)
      .then((res) => {
        setExclusiveDashboard(res?.data?.exclusive_dashboard);
      })
      .catch((err) => {
        if (err.response?.data?.message && err.response?.data?.message !== "Too Many Attempts.") {
          NotificationManager.error(err.response?.data?.message);
        }
      })
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    fetchDashboardData();
  }, [activeTab]);

  const handleBoxClick = (statusKey) => {
    let targetTab;

    if (activeTab === 0) {
      targetTab = 1; // My Dashboard -> My Leads
    } else if (activeTab === 2) {
      targetTab = 3; // Team Dashboard -> Team Leads
    } else {
      targetTab = activeTab; // fallback (optional)
    }

    const newFilterStatus = {
      this_week: false,
      total_lead_ytd: false,
      lead_not_contacted: false,
      new_lead_quarter: false,
      [statusKey]: true,
    };

    setActiveTab(targetTab);
    setCurrentPage(1);
    setFilterStatus(newFilterStatus);
  };

  const handleUnderContract = () => {
    axios
      .delete(`${BASE_URL}/mark-as-under-contract/${selectedId}`, config)
      .then((res) => {
        setSelectedId("");
        onSuccess();
        setShowContractModal(false);
        if (res?.data?.message) {
          NotificationManager.success(res?.data?.message);
        }
      })
      .catch((err) => {
        if (err.response?.data?.message && err.response?.data?.message !== "Too Many Attempts.") {
          NotificationManager.error(err.response?.data?.message);
        }
      })
      .finally(() => setLoading(false));
  };

  // Function to determine display text
  const getDisplayText = (el) => {
    if (el?.lead_type === 0 && el.portfolio !== 1) {
      if (!el?.link?.property_name) {
        return "";
      }
      return (
        <>
          <span>{el.link.property_name}</span>
          <br />
          <span>{el.link.street_address}</span>
          <br />
          <span>{el.link.city}, {el.link.state}</span>
        </>
      );
    }
    if (el?.lead_type === 1 && el.portfolio !== 1) {
      return el?.link?.property_type?.[0]?.type || '';
    }
    return el?.link?.name || '';
  };

  return (
    <BaseLayout>
      <div className="contact-header">
        <p className="head-1 dark-H">Exclusives</p>
        <div className="md:flex block gap-4 items-center">
          <div className="flex gap-4 justify-between items-center">
            <ExclusiveFilter
              filterData={filterData}
              onSetFilterData={(value) => {
                setFilterData(value);
              }}
              onCallApiAgain={(filters) => onSuccess(filters)}
            />
            <div className="search-box contacts relative">
              <input
                type="text"
                className="body-S"
                placeholder="Search name, address, city, state"
                value={searchInput}
                onChange={handleInputChange}
                style={{ border: "1px solid #D8D8D8", marginTop: "0px" }}
              />
            </div>
          </div>
        </div>
      </div>

      <div className="task-tabs mx-1 mt-2 flex justify-between body-L dark-M mb-4">
        <div className="flex gap-4">
          {["My Dashboard", "My Exclusives", "Team Dashboard", "Team Exclusives"].map((tab, index) => (
            <p
              key={index}
              role="button"
              className={`${activeTab === index ? "head-4 dark-H active" : ""} py-1`}
              onClick={() => {
                setActiveTab(index);
                setCurrentPage(1);
                // Reset filterStatus when switching tabs
                setFilterStatus({
                  exclusive_new_listing_quater: false,
                  exclusive_total_active_listing: false,
                  bov_exclusive_convertion_rate: false,
                  total_volumn: false,
                });
              }}
            >
              {tab}
            </p>
          ))}
        </div>
      </div>

      {(activeTab === 0 || activeTab === 2) && (
        <>
          <div className="flex gap-3">
            <div className="w-[70%]">
              <div className="flex items-center gap-3">
                <LeadDataContainer
                  text="NEW LISTINGS THIS QUARTER"
                  number={exclusiveDashboard?.exclusive_quarter_count}
                  onClick={() => handleBoxClick("exclusive_new_listing_quater")}
                  className="flex-1"
                />

                <LeadDataContainer
                  text="TOTAL ACTIVE LISTING"
                  number={exclusiveDashboard?.exclusive_count}
                  className="flex-1"
                  onClick={() => handleBoxClick("exclusive_total_active_listing")}
                />
                <LeadDataContainer
                  text="TOTAL VOLUME LISTED"
                  number={`$${exclusiveDashboard?.total_volumn}`}
                  className="flex-1"
                  onClick={() => handleBoxClick("total_volumn")}
                />
                <LeadDataContainer
                  text="YTD BOV TO EXCLUSIVE CONVERSION RATE "
                  number={`${exclusiveDashboard?.conversion_rate}%`}
                  onClick={() => handleBoxClick("bov_exclusive_convertion_rate")}
                  className="flex-1"
                />
              </div>

              <div className="flex gap-4 items-center">
                <CircleChart
                  Title="DAYS ON MARKET"
                  data={data}
                  TotalTitle="Total Exclusives"
                  Total={exclusiveDashboard?.total_exclusive_count}
                />

                <BarData
                  className="w-[50%]"
                  Title="PRICE POINT OF LISTINGS"
                  BarGraphData={BarGraphData}
                />
              </div>
            </div>

            <div className="w-[30%] ">
              <LeadDataContainer2
                text="LISTINGS EXPIRATION ALERT"
                data={exclusiveDashboard?.exclusive_expire_alert ?? []}
                columns={[
                  { key: "contact_name", label: "Contact Name" },
                  {
                    key: "link_name",
                    label: (
                      <>
                        Property/
                        <br />
                        Acquisition Criteria
                      </>
                    ),
                  },
                ]}
              />
            </div>
          </div>
        </>
      )}

      {(activeTab === 1 || activeTab === 3) && (
        <div className="light-bg-L pb-3 table-container">
          <div className={`${isSidebarCollapsed ? "collapsed-width" : "width"} table-info light-bg-L`}>
            {loading ? (
              <Loader />
            ) : exclusiveData?.length === 0 ? (
              <p className="body-N text-center mt-6 p-10">No Data Available</p>
            ) : (
              <table className="contact-table light-bg-L">
                <thead>
                  <tr className="uppercase body-N dark-M">
                    <th><p>Details</p></th>
                    <th>
                      <div className="table-header">
                        Initial List Date
                        <img
                          role="button"
                          src={sortBy !== "initial_list_date" ? swap : sortDirection === "desc" ? sortDesc : sortAsce}
                          onClick={() => {
                            setSortBy("initial_list_date");
                            if (sortDirection === "desc") {
                              setSortDirection("asc");
                            } else {
                              setSortDirection("desc");
                            }
                          }}
                          alt="icon"
                        />
                      </div>
                    </th>

                     <th>
                      <div className="table-header">
                          Expiration Date
                        <img
                          role="button"
                          src={sortBy !== "expiration_date" ? swap : sortDirection === "desc" ? sortDesc : sortAsce}
                          onClick={() => {
                            setSortBy("expiration_date");
                            if (sortDirection === "desc") {
                              setSortDirection("asc");
                            } else {
                              setSortDirection("desc");
                            }
                          }}
                          alt="icon"
                        />
                      </div>
                    </th>

                    <th>
                      <div className="table-header">
                        Property Name
                        <img
                          role="button"
                          src={sortBy !== "property_name" ? swap : sortDirection === "desc" ? sortDesc : sortAsce}
                          onClick={() => {
                            setSortBy("property_name");
                            if (sortDirection === "desc") {
                              setSortDirection("asc");
                            } else {
                              setSortDirection("desc");
                            }
                          }}
                          alt="icon"
                        />
                      </div>
                    </th>

                    <th>
                      <div className="table-header">
                        Status
                        <img
                          role="button"
                          src={sortBy !== "status_name" ? swap : sortDirection === "desc" ? sortDesc : sortAsce}
                          onClick={() => {
                            setSortBy("status_name");
                            if (sortDirection === "desc") {
                              setSortDirection("asc");
                            } else {
                              setSortDirection("desc");
                            }
                          }}
                          alt="icon"
                        />
                      </div>
                    </th>

                    <th>
                      <div className="table-header">
                        NOI
                        <img
                          role="button"
                          src={sortBy !== "anual_rent" ? swap : sortDirection === "desc" ? sortDesc : sortAsce}
                          onClick={() => {
                            setSortBy("anual_rent");
                            setSortDirection(sortDirection === "desc" ? "asc" : "desc");
                          }}
                          alt="icon"
                        />
                      </div>
                    </th>

                    <th>
                      <div className="table-header">
                        Asking Price
                        <img
                          role="button"
                          src={sortBy !== "asking_price" ? swap : sortDirection === "desc" ? sortDesc : sortAsce}
                          onClick={() => {
                            setSortBy("asking_price");
                            setSortDirection(sortDirection === "desc" ? "asc" : "desc");
                          }}
                          alt="icon"
                        />
                      </div>
                    </th>

                    <th>
                      <div className="table-header">
                        Asking Cap Rate
                        <img
                          role="button"
                          src={sortBy !== "asking_cap_rate" ? swap : sortDirection === "desc" ? sortDesc : sortAsce}
                          onClick={() => {
                            setSortBy("asking_cap_rate");
                            setSortDirection(sortDirection === "desc" ? "asc" : "desc");
                          }}
                          alt="icon"
                        />
                      </div>
                    </th>

                    <th>
                      <div className="table-header">
                        Listing Broker
                        <img
                          role="button"
                          src={sortBy !== "lead_type" ? swap : sortDirection === "desc" ? sortDesc : sortAsce}
                          onClick={() => {
                            setSortBy("lead_type");
                            setSortDirection(sortDirection === "desc" ? "asc" : "desc");
                          }}
                          alt="icon"
                        />
                      </div>
                    </th>

                    <th><div className="table-header">Action</div></th>
                  </tr>
                </thead>

                <tbody>
                  {exclusiveData.map((el, idx) => (
                    <React.Fragment key={idx}>
                      <tr className="dark-H body-N">
                        <td>
                          <img
                            role="button"
                            src={expandedRows[el.id] ? UpArrow : DownArrow}
                            alt="icon"
                            className="sidebar-icons"
                            onClick={() => toggleRowDetails(el.id)}
                          />
                        </td>
                        <td>{moment(el?.initial_list_date).tz('America/New_York').format("MM/DD/YY")}</td>

                          <td>{moment(el?.expiration_date).tz('America/New_York').format("MM/DD/YY")}</td>

                        <td className="head-5 capitalize">
                          <Link to={
                            el?.portfolio === 0
                              ? `/property/${el?.property_id}`
                              : el?.link?.owner_info_type === "contact"
                                ? `/contact/${el?.link?.owner?.id}`
                                : `/company/${el?.link?.owner?.id}`
                          }
                            onClick={(e) => {
                              e.preventDefault();

                              if (el?.portfolio === 0) {
                                navigate(`/property/${el?.property_id}`);
                              } else if (el?.link?.owner_info_type === "contact") {
                                navigate(`/contact/${el?.link?.owner?.id}`);
                              } else {
                                navigate(`/company/${el?.link?.owner?.id}`);
                              }
                            }}>
                            {getDisplayText(el)}
                          </Link>
                        </td>

                        <td className="text-center">
                          {el?.status_name}
                        </td>

                        <td className="text-center">
                          {el?.link?.noi_format ? `$${el.link?.noi_format.toLocaleString()}` : ""}
                        </td>

                        <td className="text-center">
                          {el?.link?.asking_price_format ? `$${el?.link?.asking_price_format.toLocaleString()}` : ""}
                        </td>

                        <td className="text-center">
                          {el?.link?.asking_cap_rate_format ? `${el.link?.asking_cap_rate_format.toLocaleString()}%` : ""}
                        </td>

                        <td className="head-5 green-H capitalize">
                          {el?.lead?.broker_details?.length > 0 ? (
                            el.lead.broker_details.map((broker) => (
                              <div key={broker.id}>
                                <Link
                                  to={`/user/${broker.id}`}
                                  onClick={(e) => {
                                    e.preventDefault();
                                    navigate(`/user/${broker.id}`);
                                  }}
                                  rel="noopener noreferrer"
                                  className="block text-gray-800 hover:text-green-700"
                                >
                                  {broker.first_name} {broker.last_name}
                                </Link>
                              </div>
                            ))
                          ) : (
                            <span>-</span>
                          )}
                        </td>

                        <td className="">
                          <ActionsMenu
                            from="Exclusives"
                            handleEdit={() => {
                              setShowEditModal(true);
                              setSelectedId(el.id);
                            }}
                            showOtherOption={true}
                            otherOptionTitle="Expired"
                            handleOtherOption={() => {
                              setShowExpiredModal(true);
                              setSelectedId(el.id);
                              setActiveDropdownTab(1);
                            }}
                            // otherUnderContractTitle={<> Convert to <br /> Under Contract</>}
                            // handleUnderContract={() => {
                            //   setSelectedId(el?.id);
                            //   setShowContractModal(true);
                            // }}
                            otherWithdrawTitle="Withdrawn"
                            handleWithdrawn={() => {
                              setShowWithdrawnModal(true);
                              setSelectedId(el.id);
                              setActiveDropdownTab(2);
                            }}
                            handleDelete={() => {
                              setSelectedId(el.id);
                              setShowDeleteModal(true);
                            }}
                          />
                        </td>
                      </tr>

                      {expandedRows[el.id] && (
                        <tr>
                          <td colSpan="11">
                            <div className="expanded-row-content p-4 bg-[rgb(244,244,244)] rounded-md">
                              <div className="flex items-center justify-between mb-7">
                                <div>
                                  <label className="dark-H head-4 block">Initial List Date</label>
                                  <p className="body-N dark-H pt-2 min-h-[1.5rem]">
                                    <span>
                                      {el?.initial_list_date ? moment(el?.initial_list_date).format("MM/DD/YYYY") : ""}
                                    </span>
                                  </p>
                                </div>

                                <div>
                                  <label className="dark-H head-4 block">Current List Date</label>
                                  <p className="body-N dark-H pt-2 min-h-[1.5rem]">
                                    <span>
                                      {el?.current_list_date ? moment(el?.current_list_date).format("MM/DD/YYYY") : ""}
                                    </span>
                                  </p>
                                </div>

                                {/* <div>
                                  <label className="dark-H head-4 block">Listing Expiration Date</label>
                                  <p className="body-N dark-H pt-2 min-h-[1.5rem]">
                                    <span>
                                      {el?.expiration_date ? moment(el?.expiration_date).format("MM/DD/YYYY") : ""}
                                    </span>
                                  </p>
                                </div> */}

                                <div>
                                  <label className="dark-H head-4 block">Days Until Listing Expires</label>
                                  <p className="body-N dark-H pt-2 min-h-[1.5rem]">
                                    <span>
                                      {el?.days_until_listing_expiration}
                                    </span>
                                  </p>
                                </div>

                                <div>
                                  <label className="dark-H head-4 block">Days on Market</label>
                                  <p className="body-N dark-H pt-2 min-h-[1.5rem]">
                                    <span className=" green-H body-S">
                                      {el?.days_on_market}
                                    </span>
                                  </p>
                                </div>
                              </div>

                              <div className="flex items-center justify-between">
                                <div>
                                  <label className="dark-H head-4 block">Client</label>
                                  <p className="body-N dark-H pt-2 min-h-[1.5rem]">
                                    <span className=" green-H body-S">
                                      <Link
                                        to={el?.contact_id ? `/contact/${el.contact_id}` : `/company/${el.company_id}`}
                                        rel="noopener noreferrer"
                                        onClick={(e) => {
                                          e.preventDefault();
                                          if (el?.contact_id) {
                                            navigate(`/contact/${el.contact_id}`);
                                          } else {
                                            navigate(`/company/${el.company_id}`);
                                          }
                                        }}
                                        className="flex items-center"
                                      >
                                        {el?.client && (
                                          <img src={contact || "/placeholder.svg"} alt="contact icon" className="sidebar-icons" />
                                        )}
                                        {el?.client}
                                      </Link>
                                    </span>
                                  </p>
                                </div>

                                <div>
                                  <label className="dark-H head-4 block">Company Commission</label>
                                  <p className="body-N dark-H pt-2 min-h-[1.5rem]">
                                    <span className=" green-H body-S">
                                      {el?.brokerage_commission ? ` ${el.brokerage_commission.toLocaleString()}%` : ""}
                                    </span>
                                  </p>
                                </div>

                                <div>
                                  <label className="dark-H head-4 block">Lease Type</label>
                                  <p className="body-N dark-H pt-2 min-h-[1.5rem]">
                                    <span>
                                      {el?.lease_type}
                                    </span>
                                  </p>
                                </div>

                                <div>
                                  <label className="dark-H head-4 block">Lease Term Remaining</label>
                                  <p className="body-N dark-H pt-2 min-h-[1.5rem]">
                                    <span>
                                      {el?.lease_team_remaining}
                                    </span>
                                  </p>
                                </div>

                                <div>
                                  <label className="dark-H head-4 block">Lease Expiration Date</label>
                                  <p className="body-N dark-H pt-2 min-h-[1.5rem]">
                                    <span>
                                      {el?.lease_expiration_date ? moment(el?.lease_expiration_date).format("MM/DD/YYYY") : ""}
                                    </span>
                                  </p>
                                </div>

                                <div>
                                  <label className="dark-H head-4 block">Gross Commission to Company</label>
                                  <p className="body-N dark-H pt-2 min-h-[1.5rem]">
                                    <span>
                                      ${el?.gross_commission_company}
                                    </span>
                                  </p>
                                </div>
                              </div>
                            </div>
                          </td>
                        </tr>
                      )}
                    </React.Fragment>
                  ))}
                </tbody>
              </table>
            )}
          </div>

          {exclusiveData?.length !== 0 && (
            <ContactPagination
              activeChildTab={activeChildTab}
              activeTab={activeTab}
              paginationData={paginationData}
              handleNext={handleNext}
              handlePrev={handlePrev}
              onSuccess={onSuccess}
              itemPerPage={itemPerPage}
              handleItemPerPageSelect={(value) => {
                setItemPerPage(value);
                setPageNumber(1);
              }}
            />
          )}
        </div>
      )}

      <AddExclusiveModal showModal={showAddModal} onClose={() => setShowAddModal(false)} onCallApi={onSuccess} />

      <EditExclusiveModal
        showModal={showEditModal}
        onClose={() => setShowEditModal(false)}
        id={selectedId}
        onCallApi={() => {
          setSelectedId("");
          onSuccess();
        }}
      />
      <DeleteConfirmationModal
        showModal={showDeleteModal}
        disable={disableDelete}
        onClose={() => setShowDeleteModal(false)}
        handleDelete={handleDelete}
      />

      <ExpiredModal
        showModal={showExpiredModal}
        onClose={() => setShowExpiredModal(false)}
        handleDelete={fetchOptions}
      />

      <ContractModal
        showModal={showContractModal}
        onClose={() => setShowContractModal(false)}
        handleUnderContract={handleUnderContract}
        id={selectedId}
      />

      <WithdrawnModal
        showModal={showWithdrawnModal}
        onClose={() => setShowWithdrawnModal(false)}
        handleDelete={fetchOptions}
      />

      <ClosedModal
        showModal={ShowClosedModal}
        onClose={() => setShowClosedModal(false)}
        handleDelete={fetchOptions}
      />
    </BaseLayout>
  );
};

export default Exclusives;